// extracted by mini-css-extract-plugin
export var label = "_6o-1";
export var reminder = "_6o-0";